import * as React from 'react';
import {Breadcrumbs, Grid} from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import ContentItem from "../../components/content-item/ContentItem";

function Customer() {
    const {t} = useTranslation();

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12} lg={12}>
                    <ContentItem>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" href="/">
                                Home
                            </Link>
                            <Typography color="text.primary">{t('Customers')}</Typography>
                        </Breadcrumbs>
                        <h1>{t('Customers')}</h1>
                        customers view here
                    </ContentItem>
                </Grid>
            </Grid>
        </div>
    );
}

export default Customer;